import Button from 'components/common/Buttons';
import TrastpilotLogo from 'components/TrastLogo';
import TrastpilotStars from 'components/TrastpilotStars';

const ReviewsInfo = ({ trustscore, reviews_count }) => {
    return (
        <div className='reviews-tristpilot'>
            <div >
                <div className='reviews-tristpilot__upperrow'>
                    <TrastpilotLogo size={"L"} />
                    <TrastpilotStars size={"L"} />
                </div>
                <div className='reviews-tristpilot__underrow'>
                    <div className='body3 reviews-tristpilot__underrow-item'>
                        <span>TrustScore</span>{trustscore}
                    </div>
                    {/* <div className='body3 reviews-tristpilot__underrow-item'>
                        {reviews_count} <span>reviews</span>
                    </div> */}
                </div>
            </div>
            <Button text={"View all reviews"} type={"outline"} to={"https://www.trustpilot.com/review/pingproxies.com"} target={true} />
        </div>
    );
}

export default ReviewsInfo;